import UserPrivilegeService from "@/entities/user-privilege/user-privilege.service";
import UserService from "@/entities/user/user.service";

export default class UserComposeService {
  userService = new UserService();
  userPrivilegeService = new UserPrivilegeService();

  public async retrieveUser() {
    const userPrivilegeRS = await this.userPrivilegeService.retrieve();
    if (userPrivilegeRS == null) {
      return [];
    }
    const userPrivileges = userPrivilegeRS.data;
    const userRS = await this.userService.retrieve();
    const users = userRS?.data || [];
    const userMap = {};
    users.forEach(e => (userMap[e.id] = e));
    userPrivileges.forEach(e => {
      e.user = userMap[e.user.id];
      e.name = e.user.login;
    });
    return userPrivileges;
  }
}
